import { render, staticRenderFns } from "./DowntimeCategories.vue?vue&type=template&id=490385d2&"
import script from "./DowntimeCategories.vue?vue&type=script&lang=js&"
export * from "./DowntimeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports